import { useEffect } from "react";

// Adds <meta name="robots" content="noindex,nofollow"> while an admin page is
// mounted, and removes it on unmount. Keeps public pages fully indexable.
export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    meta.setAttribute("data-noindex", "admin");
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
}
